export default __webpack_public_path__ + "static/media/home-blue.a68ec019.svg";